module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Keso Gradnja d.o.o.","short_name":"starter","start_url":"/","background_color":"#2860ab","theme_color":"#2860ab","display":"minimal-ui","icon":"src/images/keso-gradnja-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"92cc7c2c0724bbff6b5771b038aa769f"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
